export default [{
        title: 'Trabalhista',
        slug: 'trabalhista',
        icon: 'workers',
        white_icon: 'white_workers',
        text: 'Especialista nos direitos dos trabalhadores. Consultorias e demandas judiciais decorrentes das relações de trabalho. Referência na advocacia de Bancários, Médicos e Vigilantes.',
        full_text: `As relações de trabalho são o núcleo da sociedade moderna e o direito do trabalho é o ramo jurídico que trata do balanço e da justiça nessas relações. A área trabalhista da Crivelli Advogados Associados possui a experiência de mais de 30 anos de atuação junto a todas as esferas e instancias judiciais, na defesa dos direitos dos empregados e trabalhadores.

        As novas tecnologias estão transformando as relações sociais e também o direito do trabalho. Os trabalhadores do presente e do futuro necessitam cada vez mais de informações para tomar as decisões que afetam suas carreiras e a segurança econômica de suas vidas. 
        
        A área trabalhista está preparada para orientações, aconselhamento e análises das situações e contratos de cada empregado e trabalhador, mas também para buscar os tradicionais e novos métodos de solução dos conflitos trabalhistas, como as ações judiciais, homologações de acordos amigáveis e assessoria em comissões de conciliação voluntária, garantindo os direitos das partes com segurança jurídica e previsibilidade.
        
        A Crivelli Advogados Associados conta com especialistas em direito do trabalho em diversas cidades do país e na capital federal, para que os processos sejam acompanhados de forma diferencial no Tribunal Superior do Trabalho e no Supremo Tribunal Federal. 
        
        Nossos serviços incluem:
        
        Consultoria
        - Planejamento de carreira;
        - Análise do contrato de trabalho;
        - Consultoria sobre stock options, contrato no exterior, diretores estatutários, luvas, cláusulas de não concorrência;
        - Assessoria em homologação de rescisão do contrato de trabalho;
        - Assessoria em comissão de conciliação voluntária;
        - Assessoria em acordo extrajudicial.
        
        Atuação Judicial
        - Reclamações trabalhistas sobre horas-extras; adicional de periculosidade; reconhecimento do vínculo de emprego; equiparação salarial; insalubridade; violação dos intervalos de jornada; adicional de sobreaviso; recolhimentos previdenciários; indenização por danos morais; doenças ocupacionais; assédio moral; burnout; adicional noturno; 13º salário; férias; e outros.
        - Procedimento de homologação de acordo extrajudicial.
        
        Algumas categorias com as quais trabalhamos:
        Bancários, químicos, metalúrgicos, aeronautas, aeroviários, médicos, engenheiros, professores, servidores públicos, vigilantes, comerciários, petroleiros, trabalhadores rurais e outros.
        `
    },
    {
        title: 'Previdenciário',
        slug: 'previdenciario',
        icon: 'seniors',
        white_icon: 'white_seniors',
        text: `Consultoria, assessoria e advocacia em direito previdenciário. 
        INSS, aposentadoria privada, previdência complementar e assistência médica.`,
        full_text: `O direito previdenciário trata das questões envolvidas com o futuro, a saúde e a velhice das pessoas. Ele regula os direitos envolvidos na aposentadoria, pública e privada, mas também nos casos de afastamentos do trabalho por motivo de doenças e acidentes.

        A área previdenciária da Crivelli Advogados conta com especialistas no ramo e experiência de décadas no aconselhamento e orientação, assim como na defesa judicial e administrativa dos direitos de nossos clientes, atuando em todas as esferas e instancias judiciais e junto ao INSS.
        
         
        
        Nossos serviços incluem:
        
        Consultoria
        - Planejamento previdenciário;
        - Contagem de tempo de contribuição;
        - Cálculo da renda mensal dos benefícios;
        - Recolhimento de contribuição previdenciária;
        - Complementação de contribuição previdenciária;
        - Documentação;
        - Parecer.
        
        Atuação administrativa junto ao INSS e outros institutos de previdência
        - Requerimento de concessão de benefícios previdenciários e acidentários;
        - Requerimento de revisão de benefícios previdenciários e acidentários;
        - Regularização de períodos de trabalho;
        - Resposta às exigências do INSS;
        - Elaboração de contestação e recursos às Juntas de Recursos e ao Conselho de Recursos da Previdência Social: indeferimento de benefício; Cancelamento de benefício; Revisão e auditoria de benefício; Desconstituição do Nexo Técnico Epidemiológico Previdenciário (NTEP).
        
        Atuação judicial
        - Concessão de benefícios previdenciários e acidentários;
        - Revisão de benefícios previdenciários e acidentários (diversas teses);
        - Restabelecimento de benefícios indevidamente cessados;
        - Conversão de benefícios previdenciários em acidentário;
        - Restituição de valores indevidamente descontados das aposentadorias e pensões;
        - Isenção de imposto de renda em aposentadoria;
        - Restituição de imposto de renda indevidamente pago;
        - Demora na análise e na concessão de benefícios;
        - Regularização e reconhecimento de tempo de contribuição;
        - Dano moral previdenciário;
        - Aposentadoria complementar;
        - Aposentadoria de brasileiros que trabalham no exterior.
        
        Benefícios Previdenciários
        - Aposentadoria programada (idade e tempo de contribuição);
        - Aposentadoria da pessoa com deficiência;
        - Aposentadoria do professor;
        - Aposentadoria especial;
        - Pensão por morte;
        - Aposentadoria por incapacidade permanente previdenciária (antiga aposentadoria por invalidez);
        - Auxílio previdenciário por incapacidade temporária (antigo auxílio doença);
        - Auxílio acidente de qualquer natureza.
        
        Benefícios Acidentários
        - Aposentadoria por incapacidade permanente acidentária (antiga aposentadoria por invalidez);
        - Auxílio previdenciário por incapacidade temporária acidentária (antigo auxílio doença);
        - Auxílio acidente.
        
        Algumas das categorias com as quais trabalhamos:
        Bancários, vigilantes, professores, metalúrgicos, motoristas de caminhão, frentistas, eletricistas, químicos, jornalistas, engenheiros, aeronautas, médicos, enfermeiros, dentistas, veterinários, empresários, autônomos e outros. `
    },
    {
        title: 'Direito Civil',
        slug: 'direito-civil',
        icon: 'civil',
        white_icon: 'white_civil',
        text: 'Consultorias, assessorias e demandas judiciais de direito civil. Foco em usuários de planos de saúde e participantes de fundos de pensão.',
        full_text: `A Crivelli Advogados Associados é especialista no desenvolvimento de assessoramentos, consultorias e demandas judiciais relacionadas aos planos de saúde e fundos de pensão, atuando em todas as esferas e instancias judiciais na defesa dos direitos de nossos clientes. 

        Nossos serviços incluem:
        
        Consultoria 
        - Planejamento e análises relativas aos planos de saúde
        - Orientação jurídica sobre procedimentos cirúrgicos.
        - Planejamento e orientação sobre seguros. 
        
        Atuação judicial:
        - Aumento abusivo das mensalidades;
        - Negativa de cobertura de cirurgias de emergência, urgência ou eletiva;
        - Negativa de cobertura de tratamentos clínicos e exames;
        - Negativa de cirurgia plástica reparadora;
        - Negativa de home care;
        - Negativa de medicamentos.
        - Seguro de vida em razão de morte, invalidez ou acidentes.
        `
    },
    {
        title: 'Sindical',
        slug: 'sindical',
        icon: 'family',
        white_icon: 'white_family',
        text: `Assessoria jurídica para entidades sindicais e fundos de pensão. 
        Excelência em negociações coletivas e em direito coletivo do trabalho.`,
        full_text: `O direito sindical é o ramo do direito que trata da vida jurídica das entidades sindicais e de sua representação da coletividade de determinada categoria profissional.

        A área de direito sindical é uma das mais tradicionais da Crivelli Advogados Associados, contando com a experiência de mais de três décadas na assessoria de grandes negociações coletivas do país, assim como em dissídios e ações judiciais de direito coletivo, para a defesa dos interesses das categorias profissionais.
        
        Além da atuação judicial em todas as esferas e âmbitos judiciais, com ajuizamento de ações coletivas, recursos, processos de mediação e dissídios coletivos, a área sindical possui sólida experiência na assessoria de entidades sindicais, tanto em negociações para elaboração de acordos e convenções coletivas de trabalho, como para fundação e registro de entidades, alterações estatutárias, eleições sindicais, assembleias virtuais e reorganização do atendimento e da administração dos departamentos jurídicos de sindicatos, federações e confederações sindicais. Assessoramento também em períodos de greve ou paralisação e junto ao Ministério Público do Trabalho, Delegacias Regionais do Trabalho, e demais autoridades trabalhistas.
        
        
        
        Nossos serviços incluem:
        - Fundação e registro de entidades sindicais;
        - Elaboração e alteração de estatutos de entidades sindicais;
        - Assessoria para realização de assembleias;
        - Assessoria para eleições sindicais;
        - Assessoria para realização de assembleias e eleições virtuais;
        - Assessoria em negociações coletivas;
        - Assessoria em períodos de greve;
        - Reorganização administrativa de entidades sindicais;
        - Reorganização do departamento jurídico de entidades sindicais;
        - Ajuizamento de ações coletivas;
        - Dissídios coletivos
        - Estabelecimento de comissões de conciliação prévia e voluntária.
        - Assessoria jurídica de fundos de pensão.
        - Atuação junto ao Ministério Público do Trabalho.
        
        Algumas das categorias com as quais trabalhamos:
        Bancários, químicos, metalúrgicos, aeronautas, aeroviários, médicos,
        engenheiros, professores, servidores públicos, vigilantes, comerciários,
        petroleiros, trabalhadores rurais e outros.
        `

    }
]